import { Link } from "react-router-dom";
import { projectCardSignals } from "../content/projects/cardSignals";
import type { PublishedProject } from "../portfolio/types";

interface ProjectCardProps {
  project: PublishedProject;
  index: number;
}

/** Renders a compact project summary with optional recruiter-facing technology and discipline signals. */
export default function ProjectCard({ project, index }: ProjectCardProps) {
  const summary =
    project.sourceType === "public-overview"
      ? project.purpose[0]
      : project.summary;
  const sourceLabel =
    project.sourceType === "public-overview"
      ? `v${project.version}`
      : project.label;
  const signals = projectCardSignals[project.id] ?? [];

  return (
    <Link className="project-row-link" to={`/projects/${project.id}`}>
      <article className="project-row">
        <span className="project-number">{String(index).padStart(2, "0")}</span>
        <div className="project-row-main">
          <div className="project-row-heading">
            <h3>{project.title}</h3>
            <span>{sourceLabel}</span>
          </div>
          <p>{summary}</p>
          {signals.length > 0 && (
            <div className="project-row-signals">{signals.join(" · ")}</div>
          )}
          <div className="project-row-tags">
            <span>{project.sourceVisibility} source</span>
            <span>
              {project.sourceType === "public-overview"
                ? `released ${project.releaseDate}`
                : "README snapshot"}
            </span>
          </div>
        </div>
        <span className="project-arrow" aria-hidden="true">
          ↗
        </span>
      </article>
    </Link>
  );
}
